import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimezonesService {

  constructor() { }

    /**
   * Function used to convert time zone strings to their abbrevation.
   * If array of timeZone will send as parameter then fuction will only return abbrevation of respective values in array.
   * If doesn't receive any paramrter then return list of all timezones. 
   * @param timeZone An array of timeZones for which Abbrevation needed
   * @returns Array of Abbrevations, 
   */
    public static timeZoneAbbrevation(timeZone: string[] = []) {
      const mappingObject = {
        "Africa/Abidjan": "GMT",
        "Africa/Accra": "GMT",
        "Africa/Addis_Ababa": "EAT",
        "Africa/Algiers": "CET",
        "Africa/Asmera": "EAT",
        "Africa/Bamako": "GMT",
        "Africa/Bangui": "WAT",
        "Africa/Banjul": "GMT",
        "Africa/Bissau": "GMT",
        "Africa/Blantyre": "CAT",
        "Africa/Brazzaville": "WAT",
        "Africa/Bujumbura": "CAT",
        "Africa/Cairo": "EET",
        "Africa/Casablanca": "WEST",
        "Africa/Ceuta": "CEST",
        "Africa/Conakry": "GMT",
        "Africa/Dakar": "GMT",
        "Africa/Dar_es_Salaam": "EAT",
        "Africa/Djibouti": "EAT",
        "Africa/Douala": "WAT",
        "Africa/El_Aaiun": "WEST",
        "Africa/Freetown": "GMT",
        "Africa/Gaborone": "CAT",
        "Africa/Harare": "CAT",
        "Africa/Johannesburg": "SAST",
        "Africa/Juba": "EAT",
        "Africa/Kampala": "EAT",
        "Africa/Khartoum": "CAT",
        "Africa/Kigali": "CAT",
        "Africa/Kinshasa": "WAT",
        "Africa/Lagos": "WAT",
        "Africa/Libreville": "WAT",
        "Africa/Lome": "GMT",
        "Africa/Luanda": "WAT",
        "Africa/Lubumbashi": "CAT",
        "Africa/Lusaka": "CAT",
        "Africa/Malabo": "WAT",
        "Africa/Maputo": "CAT",
        "Africa/Maseru": "SAST",
        "Africa/Mbabane": "SAST",
        "Africa/Mogadishu": "EAT",
        "Africa/Monrovia": "GMT",
        "Africa/Nairobi": "EAT",
        "Africa/Ndjamena": "WAT",
        "Africa/Niamey": "WAT",
        "Africa/Nouakchott": "GMT",
        "Africa/Ouagadougou": "GMT",
        "Africa/Porto-Novo": "WAT",
        "Africa/Sao_Tome": "GMT",
        "Africa/Tripoli": "EET",
        "Africa/Tunis": "CET",
        "Africa/Windhoek": "CAT",
        "America/Adak": "HDT",
        "America/Anchorage": "AKDT",
        "America/Anguilla": "AST",
        "America/Antigua": "AST",
        "America/Araguaina": "BRT",
        "America/Argentina/La_Rioja": "ART",
        "America/Argentina/Rio_Gallegos": "ART",
        "America/Argentina/Salta": "ART",
        "America/Argentina/San_Juan": "ART",
        "America/Argentina/San_Luis": "ART",
        "America/Argentina/Tucuman": "ART",
        "America/Argentina/Ushuaia": "ART",
        "America/Aruba": "AST",
        "America/Asuncion": "PYT",
        "America/Bahia": "BRT",
        "America/Bahia_Banderas": "CDT",
        "America/Barbados": "AST",
        "America/Belem": "BRT",
        "America/Belize": "CST",
        "America/Blanc-Sablon": "AST",
        "America/Boa_Vista": "AMT",
        "America/Bogota": "COT",
        "America/Boise": "MDT",
        "America/Buenos_Aires": "ART",
        "America/Cambridge_Bay": "MDT",
        "America/Campo_Grande": "AMT",
        "America/Cancun": "EST",
        "America/Caracas": "VET",
        "America/Catamarca": "ART",
        "America/Cayenne": "GFT",
        "America/Cayman": "EST",
        "America/Chicago": "CDT",
        "America/Chihuahua": "MDT",
        "America/Ciudad_Juarez": "MDT",
        "America/Coral_Harbour": "EST",
        "America/Cordoba": "ART",
        "America/Costa_Rica": "CST",
        "America/Creston": "MST",
        "America/Cuiaba": "AMT",
        "America/Curacao": "AST",
        "America/Danmarkshavn": "GMT",
        "America/Dawson": "PDT",
        "America/Dawson_Creek": "MST",
        "America/Denver": "MDT",
        "America/Detroit": "EDT",
        "America/Dominica": "AST",
        "America/Edmonton": "MDT",
        "America/Eirunepe": "ACT",
        "America/El_Salvador": "CST",
        "America/Fort_Nelson": "PDT",
        "America/Fortaleza": "BRT",
        "America/Glace_Bay": "ADT",
        "America/Godthab": "WGST",
        "America/Goose_Bay": "ADT",
        "America/Grand_Turk": "EDT",
        "America/Grenada": "AST",
        "America/Guadeloupe": "AST",
        "America/Guatemala": "CST",
        "America/Guayaquil": "ECT",
        "America/Guyana": "GYT",
        "America/Halifax": "ADT",
        "America/Havana": "CDT",
        "America/Hermosillo": "MST",
        "America/Indiana/Knox": "CDT",
        "America/Indiana/Marengo": "EDT",
        "America/Indiana/Petersburg": "EDT",
        "America/Indiana/Tell_City": "CDT",
        "America/Indiana/Vevay": "EDT",
        "America/Indiana/Vincennes": "EDT",
        "America/Indiana/Winamac": "EDT",
        "America/Indianapolis": "EDT",
        "America/Inuvik": "MDT",
        "America/Iqaluit": "EDT",
        "America/Jamaica": "EST",
        "America/Jujuy": "ART",
        "America/Juneau": "AKDT",
        "America/Kentucky/Monticello": "EDT",
        "America/Kralendijk": "AST",
        "America/La_Paz": "BOT",
        "America/Lima": "PET",
        "America/Los_Angeles": "PDT",
        "America/Louisville": "EDT",
        "America/Lower_Princes": "AST",
        "America/Maceio": "BRT",
        "America/Managua": "CST",
        "America/Manaus": "AMT",
        "America/Marigot": "AST",
        "America/Martinique": "AST",
        "America/Matamoros": "CDT",
        "America/Mazatlan": "MDT",
        "America/Mendoza": "ART",
        "America/Menominee": "CDT",
        "America/Merida": "CDT",
        "America/Metlakatla": "AKDT",
        "America/Mexico_City": "CDT",
        "America/Miquelon": "PMST",
        "America/Moncton": "ADT",
        "America/Monterrey": "CDT",
        "America/Montevideo": "UYT",
        "America/Montserrat": "AST",
        "America/Nassau": "EDT",
        "America/New_York": "EDT",
        "America/Nome": "AKDT",
        "America/Noronha": "FNT",
        "America/North_Dakota/Beulah": "CDT",
        "America/North_Dakota/Center": "CDT",
        "America/North_Dakota/New_Salem": "CDT",
        "America/Ojinaga": "MDT",
        "America/Panama": "EST",
        "America/Paramaribo": "SRT",
        "America/Phoenix": "MST",
        "America/Port-au-Prince": "EDT",
        "America/Port_of_Spain": "AST",
        "America/Porto_Velho": "AMT",
        "America/Puerto_Rico": "AST",
        "America/Punta_Arenas": "CLST",
        "America/Rankin_Inlet": "CDT",
        "America/Recife": "BRT",
        "America/Regina": "CST",
        "America/Resolute": "CDT",
        "America/Rio_Branco": "ACT",
        "America/Santarem": "BRT",
        "America/Santiago": "CLST",
        "America/Santo_Domingo": "AST",
        "America/Sao_Paulo": "BRT",
        "America/Scoresbysund": "EGT",
        "America/Sitka": "AKDT",
        "America/St_Barthelemy": "AST",
        "America/St_Johns": "NDT",
        "America/St_Kitts": "AST",
        "America/St_Lucia": "AST",
        "America/St_Thomas": "AST",
        "America/St_Vincent": "AST",
        "America/Swift_Current": "CST",
        "America/Tegucigalpa": "CST",
        "America/Thule": "ADT",
        "America/Tijuana": "PDT",
        "America/Toronto": "EDT",
        "America/Tortola": "AST",
        "America/Vancouver": "PDT",
        "America/Whitehorse": "PDT",
        "America/Winnipeg": "CDT",
        "America/Yakutat": "AKDT",
        "Antarctica/Casey": "CAST",
        "Antarctica/Davis": "DAVT",
        "Antarctica/DumontDUrville": "DDUT",
        "Antarctica/Macquarie": "MIST",
        "Antarctica/Mawson": "MAWT",
        "Antarctica/McMurdo": "NZDT",
        "Antarctica/Palmer": "CLT",
        "Antarctica/Rothera": "ROTT",
        "Antarctica/Syowa": "SYOT",
        "Antarctica/Troll": "UTC",
        "Antarctica/Vostok": "VOST",
        "Arctic/Longyearbyen": "CEST",
        "Asia/Aden": "AST",
        "Asia/Almaty": "ALMT",
        "Asia/Amman": "EET",
        "Asia/Anadyr": "ANAT",
        "Asia/Aqtau": "AQTT",
        "Asia/Aqtobe": "AQTT",
        "Asia/Ashgabat": "TMT",
        "Asia/Atyrau": "AQTT",
        "Asia/Baghdad": "AST",
        "Asia/Bahrain": "AST",
        "Asia/Baku": "AZT",
        "Asia/Bangkok": "ICT",
        "Asia/Barnaul": "KRAT",
        "Asia/Beirut": "EET",
        "Asia/Bishkek": "KGT",
        "Asia/Brunei": "BNT",
        "Asia/Calcutta": "IST",
        "Asia/Chita": "IRKT",
        "Asia/Choibalsan": "CHOT",
        "Asia/Colombo": "IST",
        "Asia/Damascus": "EET",
        "Asia/Dhaka": "BDT",
        "Asia/Dili": "TLT",
        "Asia/Dubai": "GST",
        "Asia/Dushanbe": "TJT",
        "Asia/Famagusta": "EET",
        "Asia/Gaza": "EET",
        "Asia/Hebron": "EET",
        "Asia/Hong_Kong": "HKT",
        "Asia/Hovd": "HOVT",
        "Asia/Irkutsk": "IRKT",
        "Asia/Jakarta": "WIB",
        "Asia/Jayapura": "WIT",
        "Asia/Jerusalem": "IST",
        "Asia/Kabul": "AFT",
        "Asia/Kamchatka": "PETT",
        "Asia/Karachi": "PKT",
        "Asia/Katmandu": "NPT",
        "Asia/Khandyga": "YAKT",
        "Asia/Krasnoyarsk": "KRAT",
        "Asia/Kuala_Lumpur": "MYT",
        "Asia/Kuching": "MYT",
        "Asia/Kuwait": "AST",
        "Asia/Macau": "CST",
        "Asia/Magadan": "MAGT",
        "Asia/Makassar": "WITA",
        "Asia/Manila": "PHT",
        "Asia/Muscat": "GST",
        "Asia/Nicosia": "EET",
        "Asia/Novokuznetsk": "KRAT",
        "Asia/Novosibirsk": "NOVT",
        "Asia/Omsk": "OMST",
        "Asia/Oral": "ORAT",
        "Asia/Phnom_Penh": "ICT",
        "Asia/Pontianak": "WIB",
        "Asia/Pyongyang": "KST",
        "Asia/Qatar": "AST",
        "Asia/Qostanay": "QYZT",
        "Asia/Qyzylorda": "QYZT",
        "Asia/Rangoon": "MMT",
        "Asia/Riyadh": "AST",
        "Asia/Saigon": "ICT",
        "Asia/Sakhalin": "SAKT",
        "Asia/Samarkand": "UZT",
        "Asia/Seoul": "KST",
        "Asia/Shanghai": "CST",
        "Asia/Singapore": "SGT",
        "Asia/Srednekolymsk": "SRET",
        "Asia/Taipei": "CST",
        "Asia/Tashkent": "UZT",
        "Asia/Tbilisi": "GET",
        "Asia/Tehran": "IRST",
        "Asia/Thimphu": "BTT",
        "Asia/Tokyo": "JST",
        "Asia/Tomsk": "KRAT",
        "Asia/Ulaanbaatar": "ULAT",
        "Asia/Urumqi": "CST",
        "Asia/Ust-Nera": "VLAT",
        "Asia/Vientiane": "ICT",
        "Asia/Vladivostok": "VLAT",
        "Asia/Yakutsk": "YAKT",
        "Asia/Yekaterinburg": "YEKT",
        "Asia/Yerevan": "AMT",
        "Atlantic/Azores": "AZOT",
        "Atlantic/Bermuda": "ADT",
        "Atlantic/Canary": "WEST",
        "Atlantic/Cape_Verde": "CVT",
        "Atlantic/Faeroe": "WEST",
        "Atlantic/Madeira": "WEST",
        "Atlantic/Reykjavik": "GMT",
        "Atlantic/South_Georgia": "GST",
        "Atlantic/St_Helena": "GMT",
        "Atlantic/Stanley": "FKST",
        "Australia/Adelaide": "ACDT",
        "Australia/Brisbane": "AEST",
        "Australia/Broken_Hill": "ACDT",
        "Australia/Darwin": "ACST",
        "Australia/Eucla": "ACWST",
        "Australia/Hobart": "AEDT",
        "Australia/Lindeman": "AEST",
        "Australia/Lord_Howe": "LHDT",
        "Australia/Melbourne": "AEDT",
        "Australia/Perth": "AWST",
        "Australia/Sydney": "AEDT",
        "Europe/Amsterdam": "CEST",
        "Europe/Andorra": "CEST",
        "Europe/Astrakhan": "MSK",
        "Europe/Athens": "EEST",
        "Europe/Belgrade": "CEST",
        "Europe/Berlin": "CEST",
        "Europe/Bratislava": "CEST",
        "Europe/Brussels": "CEST",
        "Europe/Bucharest": "EEST",
        "Europe/Budapest": "CEST",
        "Europe/Busingen": "CEST",
        "Europe/Chisinau": "EEST",
        "Europe/Copenhagen": "CEST",
        "Europe/Dublin": "IST",
        "Europe/Gibraltar": "CEST",
        "Europe/Guernsey": "BST",
        "Europe/Helsinki": "EEST",
        "Europe/Isle_of_Man": "BST",
        "Europe/Istanbul": "TRT",
        "Europe/Jersey": "BST",
        "Europe/Kaliningrad": "EET",
        "Europe/Kiev": "EEST",
        "Europe/Kirov": "MSK",
        "Europe/Lisbon": "WEST",
        "Europe/Ljubljana": "CEST",
        "Europe/London": "BST",
        "Europe/Luxembourg": "CEST",
        "Europe/Madrid": "CEST",
        "Europe/Malta": "CEST",
        "Europe/Mariehamn": "EEST",
        "Europe/Minsk": "EEST",
        "Europe/Monaco": "CEST",
        "Europe/Moscow": "MSK",
        "Europe/Oslo": "CEST",
        "Europe/Paris": "CEST",
        "Europe/Podgorica": "CEST",
        "Europe/Prague": "CEST",
        "Europe/Riga": "EEST",
        "Europe/Rome": "CEST",
        "Europe/Samara": "SAMT",
        "Europe/San_Marino": "CEST",
        "Europe/Sarajevo": "CEST",
        "Europe/Saratov": "MSK",
        "Europe/Simferopol": "MSK",
        "Europe/Skopje": "CEST",
        "Europe/Sofia": "EEST",
        "Europe/Stockholm": "CEST",
        "Europe/Tallinn": "EEST",
        "Europe/Tirane": "CEST",
        "Europe/Ulyanovsk": "MSK",
        "Europe/Vaduz": "CEST",
        "Europe/Vatican": "CEST",
        "Europe/Vienna": "CEST",
        "Europe/Vilnius": "EEST",
        "Europe/Volgograd": "MSK",
        "Europe/Warsaw": "CEST",
        "Europe/Zagreb": "CEST",
        "Europe/Zurich": "CEST",
        "Indian/Antananarivo": "EAT",
        "Indian/Chagos": "IOT",
        "Indian/Christmas": "CXT",
        "Indian/Cocos": "CCT",
        "Indian/Comoro": "EAT",
        "Indian/Kerguelen": "TFT",
        "Indian/Mahe": "SCT",
        "Indian/Maldives": "MVT",
        "Indian/Mauritius": "MUT",
        "Indian/Mayotte": "EAT",
        "Indian/Reunion": "RET",
        "Pacific/Apia": "WSST",
        "Pacific/Auckland": "NZDT",
        "Pacific/Bougainville": "BST",
        "Pacific/Chatham": "CHADT",
        "Pacific/Easter": "EASST",
        "Pacific/Efate": "VUT",
        "Pacific/Enderbury": "PHOT",
        "Pacific/Fakaofo": "TKT",
        "Pacific/Fiji": "FJT",
        "Pacific/Funafuti": "TVT",
        "Pacific/Galapagos": "GALT",
        "Pacific/Gambier": "GAMT",
        "Pacific/Guadalcanal": "SBT",
        "Pacific/Guam": "ChST",
        "Pacific/Honolulu": "HST",
        "Pacific/Kiritimati": "LINT",
        "Pacific/Kosrae": "KOST",
        "Pacific/Kwajalein": "MHT",
        "Pacific/Majuro": "MHT",
        "Pacific/Marquesas": "MART",
        "Pacific/Midway": "SST",
        "Pacific/Nauru": "NRT",
        "Pacific/Niue": "NUT",
        "Pacific/Norfolk": "NFT",
        "Pacific/Noumea": "NCT",
        "Pacific/Pago_Pago": "SST",
        "Pacific/Palau": "PWT",
        "Pacific/Pitcairn": "PST",
        "Pacific/Ponape": "PONT",
        "Pacific/Port_Moresby": "PGT",
        "Pacific/Rarotonga": "CKT",
        "Pacific/Saipan": "ChST",
        "Pacific/Tahiti": "TAHT",
        "Pacific/Tarawa": "GILT",
        "Pacific/Tongatapu": "TOT",
        "Pacific/Truk": "TRUT",
        "Pacific/Wake": "WAKT",
        "Pacific/Wallis": "WFT"
      }
      let uniqueTimeZones = []
      if (timeZone.length) {
        let tz = new Set();
        timeZone.map(x => {
          (mappingObject[x]) && tz.add(mappingObject[x]);
        });
        uniqueTimeZones = Array.from(tz);
      }
      else {
        let tz = new Set(Object.values(mappingObject));
        uniqueTimeZones = Array.from(tz);
      }
      return uniqueTimeZones;
    }


}
